var creditCardType = require('credit-card-type');

$(function() {
    $('.js-card-number').mask('XXXX XXXX XXXX XZZZ ZZZ', {
        'translation': {
            X: {
                pattern: /[0-9]/
            },
            Z: {
                pattern: /[0-9]/,
                optional: true
            },

        }
    });

    $('.js-card-expiry').mask('XX/XX', {
        'translation': {
            X: {
                pattern: /[0-9]/
            }
        }
    });

    $('.js-card-cvc').mask('XXXZ', {
        'translation': {
            X: {
                pattern: /[0-9]/
            },
            Z: {
                pattern: /[0-9]/,
                optional: true
            },
        }
    });

    $('.js-card-number').on('input', function() {
        const card = creditCardType($(this).val().replace(/\s+/g,''));

        const cardIcon = $('[data-card-type="' + card[0].type + '"]');

        if (!$(this).val().length || !cardIcon.length) {
            $('.js-card-list').removeClass('has-card');
            $('.js-card-type').removeClass('is-hidden');

            return;
        }

        $('.js-card-list').addClass('has-card');

        $('.js-card-type').addClass('is-hidden');
        $(cardIcon).removeClass('is-hidden');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/card.js